import { InputController } from './InputController';

export default InputController;
